/*
 * � Copyright 2014 � 2025 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import React from 'react';
import {STATUS_TYPE} from '../../../../ux/ux';
import CommonCardHandler from '../../../../api/devices/common-card-devices.api';
import {cardAvailable, RESULT_CODES} from '../../../../api/devices/common-card-devices.api';
import t from '../../../../i18n/locale-keys';

const cardTestVersion = {version: 1};

class CardTest extends React.PureComponent {
    constructor(props) {
        super(props);

        this.props.setTestButtonAvailability(false);

        this.props.registerPromise(cardAvailable()
            ).then((cardMethod) => {
                if (cardMethod === RESULT_CODES.OLD_CAPTURE){
                    this.cardLoginOld();
                }
                else if (cardMethod === RESULT_CODES.NEW_CAPTURE) {
                    this.cardLoginNew()
                }
                else {
                    // we should not be here
                    this.props.markTestComplete(false, cardMethod);
                }
			})
            .catch((error) => {
                this.props.markTestComplete(false, error)
            });
    }

    render() {
        return null;
    }

    cardLoginOld() {
        this.commonCardHandler = new CommonCardHandler(CommonCardHandler.CARD_SERVICE_URL, this.props.showStatus,
            this.props.registerPromise);

        return this.commonCardHandler.getStatus({onCard: (data) => this.props.doTestLogon(data)});
    }

    cardLoginNew() {
        this.commonCardHandler = new CommonCardHandler(CommonCardHandler.NEW_CARD_SERVICE_URL, this.props.showStatus,
            this.props.registerPromise);

        this.props.doTestLogon(cardTestVersion).then((data) => {
            const {cert, nonce, version} = data;
            if (cert && nonce) {
                this.props.registerPromise(
                    this.commonCardHandler.loginCard({}, {cert, nonce, version})
                ).then((deviceServiceInitialResponse) => {
                    if (deviceServiceInitialResponse.result === RESULT_CODES.MORE_DATA) {
                        this.props.doTestLogon(deviceServiceInitialResponse).then((serverMoreDataResponse) => {
                            const {iv, message, tag} = serverMoreDataResponse;
                            this.props.registerPromise(
                                this.commonCardHandler.loginCard({}, {iv, message, tag, status: RESULT_CODES.MORE_DATA})
                            ).then((data) => {
                                const {iv, message, result, tag, version} = data;
                                const logonData = {iv, message, result, tag, version};
                                this.props.doTestLogon(logonData);
                            }).catch((error) => {
                                // Different error types: .msg (server), .message (JS exception), string (application threw)
                                const message = error.msg || error.message || error;
                                this.props.markTestComplete(false, message, STATUS_TYPE.ERROR);
                            });
                        })
                    }
                    else {
                        this.props.markTestComplete(false, t.unknownError(), STATUS_TYPE.ERROR);
                    }
                }).catch((error) => {
                    // Different error types: .msg (server), .message (JS exception), string (application threw)
                    const message = error.msg || error.message || error;
                    this.props.markTestComplete(false, message, STATUS_TYPE.ERROR);
                });
            }
            else {
                this.props.markTestComplete(false, t.unknownError(), STATUS_TYPE.ERROR);
            }
        });
    }


}

export default CardTest;
